"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createStyles = _interopRequireDefault(require("@material-ui/core/styles/createStyles"));
var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var useStyles = (0, _makeStyles.default)(theme => (0, _createStyles.default)({
  loadingContainer: {
    width: '100%',
    height: '100%',
    minHeight: '50vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  loadingLabel: {
    paddingTop: theme.spacing(2)
  }
}), {
  name: 'Loading'
});
var _default = exports.default = useStyles;